<template>
  <div>
    <card >
      <div class="filters">
        <div style="max-width: 260px">
          <div>
            <label>Дата</label>
            <datetime  v-model="params['date']"  @input="params['page'] = 1"  class="from-control" type="date" format="dd/MM/yyyy"></datetime> 
          </div>
        </div>
        <div  v-for="filter in filters" :key="filter.key" >
          <filter-item
            :nojoin="true"
            :modal="filter.key"
            :title="filter.title"
            :params="filter['params']"
            :titleKey="filter.titleKey"
            v-model="params[`${filter.field_key ? filter.field_key : filter.key}s`]"
            @input="params['page'] = 1"
          />
        </div>
      </div>
      <div class="table-full-width table-responsive visits-table-wrapper ">
        <table class="table table-hover">
          <thead>
              <th colspan="2"><div class="table-header"><div class="table-header-title text-x2">Торговый представитель / Супервайзер</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Плановый маршрут на дату</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Посещенные ТТ (общее кол-во)</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Посещенные ТТ по плану на дату</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Вне плановое посещение ТТ</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Посещенные ТТ вне маршрута на дату</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">% посещенных по плану</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Время начала маршрута</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Время окончания маршрута</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Продол-сть рабочего времени</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Максимальное время в ТТ</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Максимальное время между ТТ</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Кол-во заказов</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Сумма заказов</div></div></th>
              <th><div class="table-header"><div class="table-header-title text-x2">Средний ассортимент в заказах</div></div></th>
          </thead>
          <tbody>
            <tr 
              @click="openObject(user, 'item_user_visits')"
              v-for="user in items.data" :key="user.id" 
              :class="{'visits-table-supervisor': user.role.id == 9}"
            >
              <td :title="user.role.id == 9 ? 'Супервайзер' : 'Торговый представитель'">{{(user.role.id == 9) ? 'СВ' : 'ТП'}}</td>
              <td>{{ user.name }}</td>
              <td>{{user.plannedRouteDate}}</td>
              <td>{{user.visitedTotal}}</td>
              <td>{{user.visited_shops_planned}}</td>
              <td>{{user.new_shops_today}}</td>
              <td>{{user.visited_shops_outside_plan}}</td>
              <td>{{user.percentage_visited_planned}}</td>
              <td>{{user.route_start_time}}</td>
              <td>{{user.route_end_time}}</td>
              <td>{{user.total_working_time}}</td>
              <td>{{user.max_time_in_shop}}</td>
              <td>{{user.max_time_between_shops}}</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
</template>
<script>
import PaperTable from "../components/PaperTable";
export default {
  data() {
    return {
      items: [],
      params: {
        'date': new Date().toISOString()
      },
      loading: true,
      filters: [
        {
          key: "user",
          title: "Фильтр по кураторам",
          titleKey:'name',
          params:{
            role_code:'tp_admin-supervisor'
          },
        },
      ],
    };
  },
  methods:{
    changeFunction(val) {},
  },
  components:{
    PaperTable,
  },
  watch:{
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    lastUpdate(val) {
      if (val) {
        console.log('LAST UPDATE');
        this.getList();
      }
    },
    params: {
      handler: function (val) {
        // console.log(val.date)
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;

        // val.date = val.date.split('T')[0]
        // let query = Object.assign({}, this.$route.query);
        //   if (query['date']) {
        //     delete query['date'];
        //   }
        //   this.$router.replace({ query: {date: val.date} })

        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    getList(loading = true, resetPage = false){
      let params = this.params ? this.params : {};
      console.log(params)

      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      if (resetPage ===true){
        params['page'] = 1;
      }
      let query = Object.assign({}, this.$route.query);
      let date = params['date'].split('T')[0]
      if(query['date'] != date){
        this.$router.replace({ query: {date: date} })
      }
      this.$http
      .get("visiting-days-table", {
        params: {...params, date}
      })
      .then((response) => {
        if(!response.data)
          return
          this.items = response.data;

        if (response.data.type) {
          this.$emit("type", response.data.type);
        }
      }).catch(() => {
        
      })
      .finally(() => {
        setTimeout(() => {
          this.$loading(false);
          this.loading = false;
        }, 400);
      });
    },
    openObject(item, card, prefix = "") {
      const element = `${prefix}${card}`;
      let query = Object.assign({}, this.$route.query);
      
      if (query[element] == item.id) {
        return false;
      }
      if (query[element]) {
        delete query[element];
      }
      query[element] = item.id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
  },
  mounted(){
  
  },
  created(){
    if(this.$route.query['date'])
      this.params['date'] = new Date(this.$route.query['date']).toISOString()
      console.log(this.$route.query['date'], "this.$route.query['date']")
    // this.getList()
  },

};
</script>
<style lang="scss">


</style>